/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preset_Manager_Tab_SubtitlesInputs */



/**
* | output |
* | --- |
* | "Subtitles" |
*
* @param {Preset_Manager_Tab_SubtitlesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_tab_subtitles = /** @type {((inputs?: Preset_Manager_Tab_SubtitlesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_Tab_SubtitlesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sous-titres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertitel")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sottotitoli")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Субтитры")
	if (locale === "es") return /** @type {LocalizedString} */ ("Subtítulos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("字幕")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपशीर्षक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Legendas")
	return /** @type {LocalizedString} */ ("Subtitles")
});